<div class="envLabel" *ngIf="envName === 'dev'">{{ envName }}</div>
<p-toast></p-toast>
<router-outlet></router-outlet>